import script from "./ScreenTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenTitle.vue?vue&type=script&setup=true&lang=js"

import "./ScreenTitle.vue?vue&type=style&index=0&id=493aabf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-493aabf4"]])

export default __exports__